import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Styles } from 'toolkit/components';

interface NavItemProps {
  name: string;
  path: string;
  key: number;
  exact: boolean;
}

const NavListItem = styled.li`
  width: 200px;
  padding: 7px 0;
  @media screen and (max-width: 1000px) {
    padding-top: 3px;
  }
`;

const NavItemWrapper = ({ name, path, exact }: NavItemProps) => {
  return (
    <NavListItem>
      <NavLink
        to={`/${path}`}
        style={{
          fontWeight: 500,
          color: Styles.colors.black,
        }}
      >
        {name}
      </NavLink>
    </NavListItem>
  );
};

export default NavItemWrapper;
